export const getIcon = (key) => {
    return require(`../../assets/home-tabs/${key}.png`)
}

export const getBanner = (key) => {
    return require(`../../assets/home/banner/${key}.png`)
}